export enum VARIANTS_TYPES {
  TEXT = 'text',
  PHONE = 'phone',
  POSTCODE = 'postcode',
  ADVISER_FCA = 'adviserFCA',
  SORT_CODE = 'sortCode',
  BANK_ACC_NUMBER = 'bankAccNumber',
  CASE_NUMBER = 'caseNumber',
  YEARS = 'years',
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
  DATE = 'date',
  NUMBER = 'number',
  DECIMAL_PERCENTAGE = 'decimalPercentage',
}

export type Variants =
  | VARIANTS_TYPES.TEXT
  | VARIANTS_TYPES.PHONE
  | VARIANTS_TYPES.ADVISER_FCA
  | VARIANTS_TYPES.SORT_CODE
  | VARIANTS_TYPES.BANK_ACC_NUMBER
  | VARIANTS_TYPES.YEARS
  | VARIANTS_TYPES.CURRENCY
  | VARIANTS_TYPES.PERCENTAGE
  | VARIANTS_TYPES.POSTCODE
  | VARIANTS_TYPES.DATE
  | VARIANTS_TYPES.NUMBER
  | VARIANTS_TYPES.CASE_NUMBER
  | VARIANTS_TYPES.DECIMAL_PERCENTAGE;
